import { render, staticRenderFns } from "./WhatWeOffer.vue?vue&type=template&id=ef78ea88&scoped=true&"
import script from "./WhatWeOffer.vue?vue&type=script&lang=js&"
export * from "./WhatWeOffer.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeOffer.vue?vue&type=style&index=0&id=ef78ea88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef78ea88",
  null
  
)

export default component.exports